import { InjectionToken } from "@angular/core";

export const CORE_URL = new InjectionToken<string>("CORE_URL");